import axios from 'axios';

import {
  AUTH_TOKEN_KEY,
  clearAuth,
  isTokenExpired,
  redirectToLogin,
} from './authStorage';

const api = axios.create({
  baseURL: 'https://api.redesucodelaranja.app.br',
});

let loggingOut = false;

function forceLogout() {
  if (loggingOut) return;
  loggingOut = true;
  clearAuth();
  redirectToLogin();
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token && isTokenExpired(token)) {
    forceLogout();
    return Promise.reject(
      new axios.Cancel('Sessão expirada — redirecionando para login.'),
    );
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      forceLogout();
    }
    return Promise.reject(error);
  },
);

export default api;
